import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { AppConfig } from '../config/app.config';
import { IReturnObject } from '../shared/return-object.model';
import { Observable } from 'rxjs/Rx';
import { DistributionUnitSearch, DistributionUnitListBE } from '../distribution-unit/shared/distribution-unit.model';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';


@Injectable()
export class DistributionUnitSearchService {

    constructor(private config: AppConfig, private http: Http) { }
    private apiUrl: string = this.config.get('apiUrl') + 'DistributionUnit';
    private adminApiUrl: string = this.config.get('apiUrl') + 'Admin';

    // TODO send parameters to api
    listOfDu(duList: DistributionUnitSearch): Observable<IReturnObject> {

        let headers: Headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        let body = JSON.stringify(duList);
        let options = new RequestOptions({ headers: headers });

        return this.http.post(`${this.apiUrl}/GetDuList`, body, options)
            .map((response: Response) => <IReturnObject>response.json());

       
    };

    listOfDuCount(duCountSearch: DistributionUnitSearch): Observable<IReturnObject> {

        let headers: Headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        let body = JSON.stringify(duCountSearch);
        let options = new RequestOptions({ headers: headers });

        return this.http.post(`${this.apiUrl}/SearchDuCount`, body, options)
            .map((response: Response) => <IReturnObject>response.json());

        //let url = `${this.apiUrl}/SearchDuCount/?MHNo=${searchMHNo}` //let url = `${this.apiUrl}/GetMaterialList`
        //    + `&Description=` + searchMHDescription
        //    + `&statusListId=` + searchStatusId
        //    + `&PackagingOwnerId=` + seachIssuerUserId
        //    + `&CreateDateFrom=` + startDateFrom
        //    + `&CreateDateTo=` + startDateTo
        //    + `&includeDateSpansInSearch=` + includeDateSpansInSearch
        //    + ``;

        //return this.http.get(duCount)
        //    .map((response, Response) => <IReturnObject>response.json());
    };


    getStatuses(): Observable<IReturnObject> {
        return this.http.get(`${this.adminApiUrl}/GetStatuses`)
            .map((response: Response) => <IReturnObject>response.json());
    }
}


// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/app/distribution-unit-search/distribution-unit-search.service.ts